import { render, staticRenderFns } from "./KategoriListesi.vue?vue&type=template&id=538953bb&scoped=true&"
import script from "./KategoriListesi.vue?vue&type=script&lang=js&"
export * from "./KategoriListesi.vue?vue&type=script&lang=js&"
import style0 from "./KategoriListesi.vue?vue&type=style&index=0&id=538953bb&lang=scss&scoped=true&"
import style1 from "./KategoriListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538953bb",
  null
  
)

export default component.exports